import { render, staticRenderFns } from "./user-item.vue?vue&type=template&id=374a2a04&scoped=true"
import script from "./user-item.vue?vue&type=script&lang=js"
export * from "./user-item.vue?vue&type=script&lang=js"
import style0 from "./user-item.vue?vue&type=style&index=0&id=374a2a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a2a04",
  null
  
)

export default component.exports